






























































































































interface curAccount {
    addtax: string;
    accountBookId: number;
    startPeriod: string;
    endPeriod: string;
}

import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import MonthSelectorVue from "../components/MonthSelector.vue";
import DecTableVue from "../components/Declaration/DecTable.vue";
import SideNavVue from "../components/Declaration/SideNav.vue";

import { mapGetters } from "vuex";
import vatDeclaration from "../components/Declaration/vatDeclaration";
import version from "@/version";
@Component({
    ...mapGetters(["accountBook"]),
    components: {
        "month-selector": MonthSelectorVue,
        "dec-table": DecTableVue,
        "side-nav": SideNavVue,
    },
})
export default class Declaration extends Vue {
    isChange: boolean = false;
    curAccount: curAccount = {
        addtax: this.$store.state.accountBook.addtax,
        accountBookId: this.$store.state.accountBook.id,
        startPeriod: "",
        endPeriod: "",
    };
    activeTab: string = "";
    // 更多税种
    changeMore(command:string){
        if(command === "垃圾费"){
            this.changeClazz(6)
            return
        }
        if(command === "印花税"){
            this.changeClazz(4)
            return
        }
        if(command === "企业所得税(季度)"){
            this.changeClazz(1)
            return
        }
        if(command === "生产经营所得税"){
            this.changeClazz(2)
            return
        }
        if(command === "房产税"){
            this.changeClazz(7)
            return
        }
        if(command === "城镇土地使用税"){
            this.changeClazz(8)
            return
        }
    }
    // 一般纳税人定稿
    isSave: boolean = false;
    // 月度统计表导入
    importSales() {}

    // 定稿
    changSave(code: number) {
        if (code === 0) {
            Vue.axios
                .post(
                    `general/vat/declarations/save?accountBookId=${this.$store.state.accountBook.id}&endPeriod=${this.curAccount.endPeriod}`,
                    {
                        nothing: "",
                    }
                )
                .then((res) => {
                    this.fetchData();
                });
        } else {
            Vue.axios
                .post(
                    `general/vat/declarations/delete?accountBookId=${this.$store.state.accountBook.id}&endPeriod=${this.curAccount.endPeriod}`,
                    {
                        nothing: "",
                    }
                )
                .then((res) => {
                    this.fetchData();
                });
        }
    }
    smallChangSave(code: number) {
        console.log(this.curAccount)
        if (code === 0) {
            Vue.axios
                .post(
                    `vat/declarations/save?accountBookId=${this.$store.state.accountBook.id}&endPeriod=${this.curAccount.endPeriod}`,
                    {
                        nothing: "",
                    }
                )
                .then((res) => {
                    this.fetchData();
                });
        } else {
            Vue.axios
                .post(
                    `vat/declarations/delete?accountBookId=${this.$store.state.accountBook.id}&endPeriod=${this.curAccount.endPeriod}`,
                    {
                        nothing: "",
                    }
                )
                .then((res) => {
                    this.fetchData();
                });
        }
    }
    
    showBs: boolean = false;
    isShowBs(){
            Vue.axios
                .get(
                    `tax/record/one?period=${this.curAccount.endPeriod}&accountBookId=${this.$store.state.accountBook.id}`
                )
                .then((res) => {
                    if(res.data.taxState === 1 || res.data.taxState === 5){
                        this.showBs = true
                    }else {
                        console.log(false)
                        this.showBs = false
                    }
                });
    }
    actiondList = [
        {
            name:"财务报表",
            id:101
        },
        {
            name:"增值税",
            id:102
        },
        {
            name:"所得税",
            id:103
        },
        {
            name:"其他税种",
            id:104
        },
    ]
    actionIds = [101,102,103,104]
    showAction: boolean = false;
    // 批量报税
    closeBatch() {
        this.actionIds = [101,102,103,104]
        this.showAction = false
    }
    batchAdd() {
        this.$confirm(`亲，是否提交申报`, "温馨提示").then(
              (action: any) => {
                  if (action === "confirm") {
                    Vue.axios
                        .post(
                            `tax/record/save?period=${this.curAccount.endPeriod}&actionIds=${this.actionIds.join(",")}&ids=${
                                this.$store.state.accountBook.id
                            }&flowType=${1}`,
                            {}
                        )
                        .then((res) => {
                            this.$nextTick(()=>{
                                this.isShowBs()
                            })
                            this.fetchData();
                            this.actionIds = [101,102,103,104]
                            this.showAction = false
                        });

                  } else this.fetchData();
              }
          );
    }
    clickBs(){
        this.showAction = true
    }

    mounted() {
        let info = this.$store.state.accountBook.accountBookInfo.companyType;
        let notNull = this.$utils.notNull([info]);
        if (notNull) {
            if (this.$store.state.isOper)this.isChange = true;
            else this.isChange = false;
        } else this.isChange = false;
        if (this.curAccount.addtax === "一般纳税人") {
            this.activeTab = "generaltaxpayervatdeclaration";
        } else {
            this.activeTab = "vatDeclaration";
        }
    }

    // 选择时间
    changeDate(val: string, end: string) {
        this.curAccount.startPeriod = val;
        this.curAccount.endPeriod = val;
        if (this.$store.state.accountBook.taxFormDto.isVatMonth === 0) this.curAccount.endPeriod = end;
        this.fetchData();
    }

    // 表格数据
    curData: Declaration.Declaration | null = null;
    vatCut: any = null;
    fetchData(period?: string) {
        this.isShowBs()
        // this.isSave = false;
        let start = this.curAccount.startPeriod,
            end = this.curAccount.endPeriod;
        // 小规模主表
        if (this.activeTab === "vatDeclaration") {
            Vue.axios
                .post(
                    `vatDeclaration/find?accountBookId=${this.$store.state.accountBook.id}&period=${this.curAccount.endPeriod}`,
                    {
                        accountBookId: this.curAccount.accountBookId,
                        startPeriod: start,
                        endPeriod: end,
                    }
                )
                .then((res) => {
                    if (res.data.isSave == 1) {
                        this.isSave = true;
                    } else this.isSave = false;
                    this.curData = res.data;
                });
        }
        // 减免税表
        else if (this.activeTab === "vatcutdeclarations") {
            Vue.axios
                .get(
                    `vatcutdeclarations?accountBookId=${this.curAccount.accountBookId}&period=${end}`
                )
                .then((res) => {
                    if (res.data.isSave == 1) {
                        this.isSave = true;
                    } else this.isSave = false;
                    this.curData = res.data;
                    (<DecTableVue>this.$refs.dec).newSeri =
                        res.data.data.length + 1;
                });
            Vue.axios
                .get(
                    `vatcutdeclarationextras?accountBookId=${this.curAccount.accountBookId}&period=${end}`
                )
                .then((res) => {
                    this.vatCut = res.data;
                    (<DecTableVue>this.$refs.dec).newSeri2 =
                        res.data.data.length + 1;
                });
        }
        // 附表一
        else if (this.activeTab === "salesdetails") {
            Vue.axios
                .get(
                    `salesdetails?accountBookId=${this.curAccount.accountBookId}&period=${end}`
                )
                .then((res) => {
                    if (res.data.isSave == 1) {
                        this.isSave = true;
                    } else this.isSave = false;
                    this.curData = res.data;
                });
        }
        // 附表二
        else if (this.activeTab === "inputtaxdetails") {
            Vue.axios
                .get(
                    `inputtaxdetails/find?accountBookId=${this.curAccount.accountBookId}&period=${end}`
                )
                .then((res) => {
                    if (res.data.isSave == 1) {
                        this.isSave = true;
                    } else this.isSave = false;
                    this.curData = res.data;
                });
        }
        // 一般 主表
        else if (this.activeTab === "generaltaxpayervatdeclaration") {
            Vue.axios
                .get(
                    `generaltaxpayervatdeclaration/find?accountBookId=${this.curAccount.accountBookId}&endPeriod=${end}`
                )
                .then((res) => {
                    if (res.data.isSave == 1) {
                        this.isSave = true;
                    } else this.isSave = false;
                    this.curData = res.data;
                });
        }
        // 附表三
        else if (this.activeTab === "isAppendix3") {
            Vue.axios
                .get(
                    `vatcutdeclarations?accountBookId=${this.curAccount.accountBookId}&period=${end}&appendix=3`
                )
                .then((res) => {
                    if (res.data.isSave == 1) {
                        this.isSave = true;
                    } else this.isSave = false;
                    this.curData = res.data;
                });
        }
        // 附表四
        else if (this.activeTab === "isAppendix4") {
            Vue.axios
                .get(
                    `vatcutdeclarations?accountBookId=${this.curAccount.accountBookId}&period=${end}&appendix=4`
                )
                .then((res) => {
                    console.log(res);
                    if (res.data.isSave == 1) {
                        this.isSave = true;
                    } else this.isSave = false;
                    this.curData = res.data;
                });
        }
    }

    changeVal(row: vatDeclaration) {
        Vue.axios
            .post(`vatDeclaration/save`, {
                id: null,
                accountBookId: this.curAccount.accountBookId,
                startPeriod: this.curAccount.endPeriod,
                endPeriod: this.curAccount.endPeriod,
                row: row.row,
                goods: row.val1,
                service: row.val2,
            })
            .then((res) => {
                this.fetchData();
            })
            .catch(() => {
                this.fetchData();
            });
    }
    // 切换所得税申报表
    changeClazz(number: number) {
        if (number === 0) this.fetchData();
        else if (number === 1) this.$router.push({ path: "/EITQuarter" });
        else if (number === 3) this.$router.push({ path: "/AnnualEIT" });
        else if (number === 4) this.$router.push({ path: "/StampTax" });
        else if (number === 6) this.$router.push({ path: "/Rubbish" });
        else if (number === 7) this.$router.push({ path: "/PropertyTax" });
        else if (number === 8) this.$router.push({ path: "/LandUseTax" });
        else this.$router.push({ path: "/ProductionOperationTax" });
    }
    pdf(){
        let urls = ""
        const rows = `?accountBookId=${this.$store.state.accountBook.id}&period=${this.curAccount.endPeriod}&version=${version}&token=${this.$store.state.account.token}`
        // 小规模主表
        if (this.activeTab === "vatDeclaration") {
            urls = `${Vue.axios.defaults.baseURL}export/pdf/vatdeclaration` + rows;
        }
        // 减免税表
        else if (this.activeTab === "vatcutdeclarations") {
            urls = `${Vue.axios.defaults.baseURL}export/pdf/vat/table6` + rows;

        }
        // 附表一
        else if (this.activeTab === "salesdetails") {
            urls = `${Vue.axios.defaults.baseURL}export/pdf/salesdetail` + rows;

        }
        // 附表二
        else if (this.activeTab === "inputtaxdetails") {
            urls = `${Vue.axios.defaults.baseURL}export/pdf/inputtaxdetails` + rows;

        }
        // 一般 主表
        else if (this.activeTab === "generaltaxpayervatdeclaration") {
            urls = `${Vue.axios.defaults.baseURL}export/pdf/generalvatdeclaration` + rows;

        }
        // 附表三
        else if (this.activeTab === "isAppendix3") {
            urls = `${Vue.axios.defaults.baseURL}export/pdf/vat/table3` + rows;

        }
        // 附表四
        else if (this.activeTab === "isAppendix4") {
            urls = `${Vue.axios.defaults.baseURL}export/pdf/vat/table4` + rows;

        }
        this.$store.dispatch("toggleDownload", true);
        this.$utils.sendToElectron("download", urls);
    }

    usePlugin() {
        this.$utils.oneKeyLogin(this.$store.state.accountBook.id, this, "一键登录");
    }
}
